var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"work"},[_c('div',{staticClass:"outsideWrapper"},[_c('div',{staticClass:"insideWrapper"},[_c('img',{staticClass:"img",attrs:{"src":_vm.work.imageUrl,"alt":_vm.work.title,"id":"image"}}),_c('canvas',{staticClass:"coveringCanvas hover",class:{ hide: !this.showPoints },attrs:{"id":"canvas"},on:{"click":_vm.checkPoint}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }